import React from 'react';
import Modal, {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@bitComponents/unifiedComponents/Modal';
import {
  LIGHT_BOX_CONTENT,
} from '@bitComponents/utils/tagging';
import OTPModalContent from './otpModalContent';

const closeModal = () => {
  Modal.hide();
};

const setModalContent = ({
  taggingInfo,
  phoneNumber,
}) => {
  return (
    <OTPModalContent
      taggingInfo={taggingInfo}
      closeModal={closeModal}
      phoneNumber={phoneNumber}
    />
  );
};

export const showRegisterOTPModal = (phoneNumber) => {
  const taggingInfo = {
    componentName: 'register-otp-modal',
    componentContent: 'otp-modal',
    componentProduct: '',
    componentVariation: 'all',
  };
  Modal.setContent(
    setModalContent({
      taggingInfo,
      phoneNumber,
    }),
  );
  Modal.setModalProps({
    closeByClickingOutside: true,
    inSceneEffect: IN_SCENE_EFFECT.FADE_IN,
    outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT,
    contentPosition: CONTENT_POSITION.CENTER_CENTER,
    taggingInfoWhenClickingOutside: {
      ...taggingInfo,
      componentContent: `register-otp-modal-${LIGHT_BOX_CONTENT.CLICK_OUTSIDE}`,
    },
    taggingInfo,
  });
  Modal.show();
};
